module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-md-1-5 pure-u-lg-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-3-5 pure-u-lg-1-2"
  }, [_c('div', {
    staticClass: "content box padding-30-reactive"
  }, [_c('p', [_vm._v("\n        Keep an eye on your inbox! Great beer coming to you soon!\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-g",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "pure-u-1"
  }, [_c('img', {
    staticStyle: {
      "width": "209px",
      "height": "209px"
    },
    attrs: {
      "src": require("../../assets/images/horusCrownedEagle.png")
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("\n        If you have any questions, concerns or comments, please email\n        "), _c('a', {
    attrs: {
      "href": "mailto:support@tavour.com"
    }
  }, [_vm._v("support@tavour.com")]), _vm._v(".\n      ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39aabb8b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/success/SuccessHorusCrownedEagle.vue
// module id = 370
// module chunks = 1